module.exports = __webpack_public_path__ + "img/roll_d copy.ed742970.png";